import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_198: DocMigration = {
  maxSchemaVersion: "0.0.198",
  description: "Cleanup orphaned opening groups",
  apply(json: any) {
    const groupIdsWithInstanceCount: { [groupId: string]: number } = {};

    for (const hash in json.entityGroups) {
      if (!hash.startsWith("opening")) {
        continue;
      }
      const hashArr = hash.split(".");

      if (hashArr.length !== 2) {
        continue;
      }

      const groupId = json.entityGroups[hash];
      let count = groupIdsWithInstanceCount[groupId] || 0;
      const opening = json.openings[hashArr[1]];
      if (opening) {
        count++;
      } else {
        delete json.entityGroups[hash];
      }
      groupIdsWithInstanceCount[groupId] = count;
    }

    for (const groupId in groupIdsWithInstanceCount) {
      const count = groupIdsWithInstanceCount[groupId];
      if (count === 0 && json.groups[groupId]) {
        delete json.groups[groupId];
      }
    }

    return json;
  },
};

export default migration_0_0_198;
